module.exports = __webpack_public_path__ + "media/assets/icons/menu-2031edcd573a9caab6006d21c79c17f5.svg";